export default __webpack_public_path__ + "c24638ff0eb13abbffd1d8e2fd4bb84d.svg";